import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const DEFAULT_FAVICON = `${process.env.PUBLIC_URL}/favicon.ico?v=3`

const setIconHref = (href) => {
    document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach(link => {
        link.href = href
    })
}

/**
 * Uses the "Dashboard Nav Logo (Collapsed)" upload as the browser-tab icon.
 * Read-only: the logos are fetched by useSiteLogos() in the layout.
 *
 * The image is fetched and handed to the <link> as a blob URL because the
 * backend's /storage/logos route rejects requests without our Referer, and
 * browsers don't reliably send one for favicon loads. If the fetch fails
 * (e.g. a Spaces URL without CORS), the URL is used directly.
 */
function useSiteFavicon() {

    const url = useSelector(state => state.settings.logo?.['nav-collapsed'])

    useEffect(() => {
        if (!url) {
            setIconHref(DEFAULT_FAVICON)
            return
        }

        let objectUrl = null
        let cancelled = false

        fetch(url)
            .then(resp => {
                if (!resp.ok) throw new Error('logo fetch failed')
                return resp.blob()
            })
            .then(blob => {
                if (cancelled) return
                objectUrl = URL.createObjectURL(blob)
                setIconHref(objectUrl)
            })
            .catch(() => {
                if (!cancelled) setIconHref(url)
            })

        return () => {
            cancelled = true
            if (objectUrl) URL.revokeObjectURL(objectUrl)
        }
    }, [url])
}

export default useSiteFavicon
